export type DotType = 'square' | 'dots' | 'rounded' | 'extra-rounded' | 'classy' | 'classy-rounded'
export type CornerSquareType = 'square' | 'dot' | 'extra-rounded'
export type CornerDotType = 'square' | 'dot'

export interface QRSettings {
  value: string
  size: number
  bgColor: string
  fgColor: string
  dotType: DotType
  cornerSquareType: CornerSquareType
  cornerDotType: CornerDotType
  ecLevel: 'L' | 'M' | 'Q' | 'H'
  logoImage?: string
  logoSize: number
  margin: number
  borderWidth: number
  borderRadius: number
  borderColor: string
}

export const defaultQRSettings: QRSettings = {
  value: 'https://excelschools.edu.in',
  size: 256,
  bgColor: '#ffffff',
  fgColor: '#000000',
  dotType: 'square',
  cornerSquareType: 'square',
  cornerDotType: 'square',
  ecLevel: 'M',
  logoImage: undefined,
  logoSize: 50,
  margin: 10,
  borderWidth: 0,
  borderRadius: 0,
  borderColor: '#000000',
}
